import { SaleDetailModel } from 'api-hooks/sale/model';
import { capitalize, generateId } from 'common/utils/string';
import React from 'react';

import {
  ActivityRescheduleFormType,
  ActivitySaleAddOnsType,
  ActivitySaleGuestDetailType,
  ActivitySaleGuestType,
  ActivitySaleType,
} from '../form-type';

interface Props {
  activitySale: SaleDetailModel;
}

export default function useGetDefaultValues(props: Props) {
  const { activitySale } = props;

  const defaultValues = React.useMemo<ActivityRescheduleFormType>(() => {
    const activitySales: ActivitySaleType[] = activitySale.activitySales.map(
      (as) => {
        //guest
        const activitySaleGuests: ActivitySaleGuestType[] =
          as.activitySaleGuests.map((asg) => {
            const activitySaleGuestDetails: ActivitySaleGuestDetailType[] =
              asg.activitySaleGuestDetails.map((asgd) => ({
                activityId: asgd.activity.id,
                activityName: asgd.activity.name,
                date: asgd.date,
                description: asgd.description,
                id: asgd.id,
                isSelected: false,
                price: asgd.price,
                qty: asgd.qty || 1,
                totalPrice: asgd.totalPrice || 0,
                type: capitalize(asgd.activity.type),
                customId: generateId(),
              }));
            return {
              customId: generateId(),
              guestId: asg.guest.id,
              guestName: [asg.guest.title, asg.guest.name].join(' '),
              id: asg.id,
              preferences: [],
              guestPreferences: [
                ...asg.guest.preferences,
                ...asg.guest.preferenceStats,
              ].map((item: any) => ({
                id: item.id,
                label: item.count ? `${item.name} (X${item.count})` : item.name,
              })),
              isSelected: false,
              activitySaleGuestDetails,
              originalActivitySaleGuestDetails: activitySaleGuestDetails,
            };
          });

        //addons
        const activitySaleAddOns: ActivitySaleAddOnsType[] =
          as.activitySaleAddOns.map((asao) => ({
            description: asao.description,
            guestId: asao.guest.id,
            id: asao.id,
            isSelected: false,
            price: asao.price,
            customId: generateId(),
          }));

        return {
          id: as.id,
          isGroupedPrice: as.isGroupedPrice,
          activitySaleAddOns,
          activitySaleGuests,
        };
      },
    );
    return {
      customer: [
        activitySale.customer.name,
        activitySale.customer.alias,
        activitySale.customer.phone,
      ]
        .filter((val) => !!val)
        .join(' - '),
      activitySales,
      invoiceNumber: activitySale.invoiceNumber,
      transactionAt: new Date(),
      total: 0,
    };
  }, [activitySale]);

  return defaultValues;
}
